import { render } from "./IndexFeatured.vue?vue&type=template&id=d2757ea0"
import script from "./IndexFeatured.vue?vue&type=script&lang=js"
export * from "./IndexFeatured.vue?vue&type=script&lang=js"

import "./IndexFeatured.vue?vue&type=style&index=0&id=d2757ea0&lang=css"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__